import Team from '../../entities/Team/ui/Team';
import Footer from '../../widgets/Footer/ui/FooterContact/Footer';
import FooterInfo from '../../widgets/Footer/ui/FooterInfo/FooterInfo';
import HeaderTeam from '../../widgets/HeaderTeam/ui/HeaderTeam';
import styles from './AboutPage.module.scss';

export const AboutPage = () => {
    return(
        <div  className={styles.team}>
            <HeaderTeam/>
            <Team/>
            <Footer/>
            <FooterInfo/>
        </div>
    )
}